// extracted by mini-css-extract-plugin
module.exports = {"title":"title--2zZwR"};